import { Badge, Popconfirm, message } from "antd";
import React from "react";
import { AiOutlinePoweroff, AiOutlineUsergroupAdd } from "react-icons/ai";
import { FaRegFile } from "react-icons/fa";
import { FiUploadCloud } from "react-icons/fi";
import { LuBrainCircuit, LuFileCode2, LuHistory } from "react-icons/lu";
import {
  MdOutlineAddLocationAlt,
  MdOutlineAutoGraph,
  MdOutlineLocalHospital,
} from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import { logOut } from "../../helpers/authFunctions";
import { LOCAL_IMAGE } from "../../images/ImageConstant";
import { CM, FL, ML, PA, PFA, SM } from "../../pages/router/AddRoutesJson";
import AccessTo from "../is-show/AccessTo";
import "./sidebar.scss";
import useFLProjectList from "../hooks/useFLProjectList";
import { BsRobot } from "react-icons/bs";
import { GrDocumentLocked } from "react-icons/gr";
import { TbDatabaseCog } from "react-icons/tb";
import { useQuery } from "@tanstack/react-query";
import { getProjectCount } from "../../api/apiCallManager";
import { GoHistory } from "react-icons/go";

function Sidebar() {
  const {
    data: projectCount,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["projectCount_projectCount"],
    queryFn: getProjectCount,
  });
  const location = useLocation();
  const confirm = async (e) => {
    message.loading({
      content: "Please wait, logging out...",
      key: "logout-loading",
    });
    logOut();
  };
  const projects = [
    {
      name: `Federated Learning `,
      count: projectCount?.project_count || 0,
      link: "/fl-project",
      activeIdentifier: [
        "/fl-project",
        "/preview-fl-project/",
        "/create-fl-project",
      ],
      icon: <TbDatabaseCog size={15} />,
      accessTo: [PFA, PA, CM, FL, SM, ML],
    },
    {
      name: "Machine Learning",
      count: 0,
      link: "/ml-project",
      activeIdentifier: ["/ml-project", "/create-ml-project"],
      icon: <LuBrainCircuit />,
      accessTo: [PFA, PA, CM, SM, FL, ML],
    },
  ];

  const others = [
    {
      name: "User Management",
      count: 0,
      link: "/manage-role",
      activeIdentifier: ["/manage-role"],
      icon: <AiOutlineUsergroupAdd size={17} />,
      accessTo: [PFA],
    },
    {
      name: "Uploaded History",
      count: 0,
      link: "/upload-data",
      activeIdentifier: ["/upload-data"],
      icon: <LuHistory size={14} />,
      accessTo: [SM],
    },
    {
      name: "Manage Clients",
      count: 0,
      link: "/manage-clients",
      activeIdentifier: ["/manage-clients"],
      icon: <MdOutlineAddLocationAlt size={14} />,
      accessTo: [PA],
    },
    // {
    //   name: "EDA",
    //   count: 0,
    //   link: "/eda-data",
    //   activeIdentifier: ["/eda-data"],
    //   icon: <MdOutlineAutoGraph />,
    //   accessTo: [CM],
    // },
  ];

  const isActive = (activeIdentifiers) =>
    activeIdentifiers.some((identifier) =>
      location.pathname.startsWith(identifier)
    );
  return (
    <div className=" sticky top-0">
      {/* {JSON.stringify(projectCount)} */}
      <div className=" bg-[#ffffff]  h-[100vh] brd-r  sticky  top-0  ">
        <div className="p-4">
          <div className="flex items-center">
            <Link to="/fl-project">
              <img src={LOCAL_IMAGE.LOGO} className="h-[40px] object-contain" />
            </Link>
          </div>
          <AccessTo role={[PFA, PA, ML, FL, CM, SM]}>
            <h2 className=" px-2 pt-12 pb-5 font-medium text-[14px] text-[#9DA3AA]">
              PROJECTS
            </h2>
            <ul className=" space-y-4  px-2  text-[14px]">
              {projects.map((project, index) => (
                <li
                  key={index}
                  className={
                    isActive(project.activeIdentifier) ? "sbl-active" : ""
                  }
                >
                  <Link
                    to={project.link}
                    className="flex items-center w-[165px]"
                  >
                    <span>{project.icon}</span>
                    <span className="ms-1">{project.name}</span>
                    <span className="ms-auto">{project.count}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </AccessTo>
          <AccessTo role={[PFA, PA, SM]}>
            <div className="py-2"></div>
            <hr></hr>
            <div className="py-2"></div>
            <h2 className=" px-2 pb-5 font-medium text-[14px] text-[#9DA3AA]">
              OTHERS
            </h2>
          </AccessTo>
          <ul className=" space-y-4  px-2  text-[14px]">
            {others.map((oList, index) => (
              <AccessTo role={oList.accessTo} key={index}>
                <li
                  className={
                    isActive(oList.activeIdentifier) ? "sbl-active" : ""
                  }
                >
                  <Link to={oList.link} className="flex items-center">
                    <span>{oList.icon}</span>
                    <span className="ms-1">{oList.name}</span>
                  </Link>
                </li>
              </AccessTo>
            ))}
          </ul>

          {/* <Link to="/profile">
            <button className="setting-btn !bottom-[50px]">
              <span className="bg-container ">
                <IoSettingsOutline size={14} />
              </span>
              <div className="mx-4">Settings</div>
            </button>
          </Link> */}
          <Popconfirm
            title="Logout"
            description="Are you sure to logout?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"
          >
            <button className="setting-btn  ">
              <span className="bg-container  ">
                <AiOutlinePoweroff size={14} />
              </span>
              <div className="mx-4">Logout</div>
            </button>
          </Popconfirm>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
